import { render, staticRenderFns } from "./NoticeListLayout.vue?vue&type=template&id=74542eaf&scoped=true&lang=pug&"
import script from "./NoticeListLayout.vue?vue&type=script&lang=ts&"
export * from "./NoticeListLayout.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeListLayout.vue?vue&type=style&index=0&id=74542eaf&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74542eaf",
  null
  
)

export default component.exports